import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import css from '@styled-system/css';
import propTypes from '@styled-system/prop-types';
import styled from 'styled-components';
import { background, border, color, compose, flexbox, grid, layout, opacity, position, shadow, space } from 'styled-system';
const StyledContainer = styled.div.withConfig({
  displayName: "StyledContainer",
  componentId: "sc-sdy56u-0"
})(["&&&{", "}"], compose(space, background, border, color, layout, flexbox, opacity, position, shadow));
StyledContainer.propTypes = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, propTypes.space), propTypes.border), propTypes.color), propTypes.layout), propTypes.flexbox), propTypes.position), propTypes.shadow);
export const FullWidthContainer = styled(StyledContainer).withConfig({
  displayName: "FullWidthContainer",
  componentId: "sc-sdy56u-1"
})(css({
  width: '100%'
}));
FullWidthContainer.propTypes = StyledContainer.propTypes;
export const FullWidthFullHeightViewportContainer = styled(FullWidthContainer).withConfig({
  displayName: "FullWidthFullHeightViewportContainer",
  componentId: "sc-sdy56u-2"
})(css({
  minHeight: '100vh'
}));
FullWidthFullHeightViewportContainer.propTypes = StyledContainer.propTypes;
export const Container = styled(FullWidthContainer).withConfig({
  displayName: "Container",
  componentId: "sc-sdy56u-3"
})(css({
  maxWidth: ['527px', '927px', '1199px'],
  px: 3,
  mx: 'auto'
}));
Container.propTypes = FullWidthContainer.propTypes;
export const Box = styled(StyledContainer).withConfig({
  displayName: "Box",
  componentId: "sc-sdy56u-4"
})(css({
  boxSizing: 'border-box',
  minWidth: 0
}));
Box.propTypes = StyledContainer.propTypes;
export const Flex = styled(Box).withConfig({
  displayName: "Flex",
  componentId: "sc-sdy56u-5"
})(css({
  display: 'flex'
}));
Flex.propTypes = Box.propTypes;
export const Row = styled(Flex).withConfig({
  displayName: "Row",
  componentId: "sc-sdy56u-6"
})(css({
  mx: -2,
  flexWrap: 'wrap'
}));
Row.propTypes = Flex.propTypes;
export const Col = styled(Box).withConfig({
  displayName: "Col",
  componentId: "sc-sdy56u-7"
})(css({
  width: '100%',
  flex: '0 1 auto',
  px: 2
}));
Col.propTypes = Box.propTypes;
export const Grid = styled(Box).withConfig({
  displayName: "Grid",
  componentId: "sc-sdy56u-8"
})(grid, css({
  display: 'grid'
}));
export const GridItem = styled(Box).withConfig({
  displayName: "GridItem",
  componentId: "sc-sdy56u-9"
})(["&&&{", "}"], grid);
Grid.propTypes = _objectSpread(_objectSpread({}, Box.propTypes), propTypes.grid);